<div [formGroup]="form">
	<h2 mat-dialog-title>{{ data.titleKey | translate }}</h2>
	<div mat-dialog-content>
		<mat-form-field>
			<mat-label>{{ "i18n.property.code_value" | translate }}</mat-label>
			<input id="codelist-value" formControlName="value" matInput #focusInputField />
			@if (form.get("value")?.errors?.whitespace) {
				<mat-error>{{ "i18n.error.whitespace" | translate }}</mat-error>
			}
			@if (form.get("value")?.errors?.required) {
				<mat-error>
					{{ "i18n.error.required" | translate }}
				</mat-error>
			}
			@if (form.get("value")?.errors?.codeExists) {
				<mat-error>
					{{ "i18n.error.code_exists" | translate }}
				</mat-error>
			}
		</mat-form-field>

		<mat-form-field>
			<mat-label>{{ "i18n.property.parent_code" | translate }}</mat-label>
			<input
				id="codelist-parentCode"
				type="text"
				#parentCodeInput
				formControlName="parentCode"
				matInput
				(input)="onParentCodeInputChanged(parentCodeInput.value)"
				[matAutocomplete]="parentCodeAutocomplete"
			/>
			<mat-autocomplete #parentCodeAutocomplete="matAutocomplete" autoActiveFirstOption="true">
				@for (parentCodeValue of searchCodeListEntries$ | async; track parentCodeValue) {
					<mat-option id="{{ parentCodeValue }}" [value]="parentCodeValue">
						{{ parentCodeValue }}
					</mat-option>
				}
			</mat-autocomplete>
			@if (form.get("parentCode")?.errors?.parentCodeNotExists) {
				<mat-error>
					{{ "i18n.error.parent_code_not_exists" | translate }}
				</mat-error>
			}
		</mat-form-field>

		<mat-form-field>
			<mat-label>{{ "i18n.property.valid_from" | translate }}</mat-label>
			<input id="validFrom_CodeList" matInput [matDatepicker]="validFromDatePicker" formControlName="validFrom" />
			<mat-datepicker-toggle matSuffix [for]="validFromDatePicker"></mat-datepicker-toggle>
			<mat-datepicker #validFromDatePicker></mat-datepicker>
		</mat-form-field>

		<mat-form-field>
			<mat-label>{{ "i18n.property.valid_to" | translate }}</mat-label>
			<input id="validFrom_CodeList" matInput [matDatepicker]="validToDatePicker" formControlName="validTo" />
			<mat-datepicker-toggle matSuffix [for]="validToDatePicker"></mat-datepicker-toggle>
			<mat-datepicker #validToDatePicker></mat-datepicker>
		</mat-form-field>

		<h3 mat-dialog-title>{{ "i18n.title.codename" | translate }}</h3>

		@for (lang of data.contentLanguages; track lang) {
			<mat-form-field formGroupName="name">
				<mat-label>{{ "i18n.property.codename_" + lang | translate }}</mat-label>
				<input id="codelist-codename-{{ lang }}" formControlName="{{ lang }}" matInput />
				@if (form.get(["name", lang]) | isinvalidanduntouched | async) {
					<mat-hint>{{ "i18n.hint.multilingual_name" | translate }}</mat-hint>
				}
				<mat-error>{{ "i18n.multilingual.error.name" | translate }}</mat-error>
			</mat-form-field>
		}

		<h3 mat-dialog-title>{{ "i18n.property.description" | translate }}</h3>

		@for (lang of data.contentLanguages; track lang) {
			<mat-form-field formGroupName="description">
				<mat-label>{{ "i18n.property.description" | translate }} ({{ lang | uppercase }})</mat-label>
				<textarea matInput id="codelist-description-{{ lang }}" formControlName="{{ lang }}"></textarea>
			</mat-form-field>
		}
	</div>

	<div mat-dialog-actions>
		<button type="button" id="codelist-cancel-button" mat-button obButton="tertiary" matTooltip=" {{ 'i18n.tooltip.cancel' | translate }}" mat-dialog-close>
			{{ "i18n.button.cancel" | translate }}
		</button>
		<button
			mat-button
			id="codelist-submit-button"
			type="button"
			obButton="primary"
			matTooltip=" {{ 'i18n.tooltip.save' | translate }}"
			(click)="safeClick()"
			cdkFocusInitial
			[disabled]="disableSave"
		>
			{{ "i18n.button.save" | translate }}
		</button>
	</div>
</div>
